module.exports = "<div class=\"gw-breadcrumbs\" gw-partial=\"Item\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/layouts/templates/Breadcrumbs.html
// module id = 582
// module chunks = 0